/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { handleTokenAuth } from './api'
import { reloadUniversalTrackerValues } from './universalTracker';
import { API } from '../constants/errors';
import { getSafeErrorMessage } from './error';
import G17Client, { formDataConfig, formDataHeaders } from '../services/G17Client';

export const UpdateActions = {
  STATUS: {
    UPDATE: 'update',
    VERIFY: 'verify',
    REJECT: 'reject'
  },
  ACTION: {
    FRAMEWORK: {
      OUTSTANDING: 'outstanding',
      COMPLETED: 'completed'
    },
    UTR: {
      CREATED: 'created',
      VERIFIED: 'verified',
      UPDATED: 'updated',
      REJECTED: 'rejected'
    },
    MESSAGES: {
      'created': 'Not Submitted',
      'verified': 'Verified',
      'updated': 'Pending Verification',
      'rejected': 'Rejected',
    }
  }
};

export function saveUniversalTrackerValue(action, utrValueId, data) {
  const url = `/universal-tracker-values/${utrValueId}/${action}`;

  return async (dispatch, getState) => {
    const options = handleTokenAuth(getState);
    options.headers = { ...options.headers, ...formDataHeaders };
    return G17Client.patch(url, data, options)
      .then((result) => {

        dispatch(reloadUniversalTrackerValues());
        dispatch({ type: actionTypes.UNLOAD_USER_TRACKER_ACTIONS });

        return result;
      }).catch(e => {
        throw new Error(getSafeErrorMessage(e));
      });
  }
}

export function createUniversalTrackerValue(data) {
  const url = '/universal-tracker-values';

  return (dispatch, _getState) => {

    return G17Client.post(url, data, formDataConfig)
      .then((result) => {

        dispatch(reloadUniversalTrackerValues());
        dispatch({ type: actionTypes.UNLOAD_USER_TRACKER_ACTIONS });
        return result;
      }).catch(e => {
        console.log(e);
        throw new Error(e.response ? API.GENERIC : e.message);
      });
  }
}
